import { render } from "./SimpleNavBar.vue?vue&type=template&id=2a2df029&scoped=true"
import script from "./SimpleNavBar.vue?vue&type=script&lang=js"
export * from "./SimpleNavBar.vue?vue&type=script&lang=js"

import "./SimpleNavBar.vue?vue&type=style&index=0&id=2a2df029&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2df029"]])

export default __exports__